export const ROUTES = {
    AssignmentsPage: "/assignments",
    Dashboard: "/",
    Profile: "/profile",
    WorkPlan: "/work-plan",
    WorkPlanMarketDetails: "/work-plan/details/:marketId",
    AssignmentTask: "/work-plan/:marketId/customTask/:taskId",
    WorkPlanUnplannedMarket: "/work-plan/unplanned-market",
    AssortmentMatrix: "/work-plan/:marketId/assortmentMatrix/:taskId",
    DMP: "/work-plan/:marketId/dmp/:taskId",
    PromoTagPhotos: "/work-plan/:marketId/promoTagPhotos/:taskId",
    SetGeoLocationTask: "/work-plan/:marketId/setGeoLocation/:taskId",
    AddPhotoTask: "/work-plan/:marketId/addPhoto/:taskId",
    TakeDebtTask: "/work-plan/:marketId/takeDebt/:taskId",
    SaleAdditionalTask: "/work-plan/:marketId/saleAdditional/:taskId",
    UpdateMarketInfoTask: "/work-plan/:marketId/updateMarketInfo/:taskId",
    RejectProductsTask: "/work-plan/:marketId/rejectProducts/:taskId",
    MarketDetails: "/work-plan/details/:marketId",
    MarketVerifyAddress: "/work-plan/details/:marketId/verify-address",
    UpdateProductBalancesTask:
        "/work-plan/:marketId/updateProductBalances/:taskId",

    NewRouteMarketCreate: "/route-management-sv/new-route/create-market",

    ProductPage: "/work-plan/product-card/:barcode",

    // Checkout
    CheckoutOrderDetails: "/checkout/:orderId/order-details",
    Checkout: "/checkout",
    SVCheckout: "/sv-checkout",
    CheckoutAddProducts: "/:isCheckout/:marketId/addProducts/:orderId",

    // Auth
    Login: "/login",
    ConfirmOtp: "/confirm-otp",

    // SV
    Team: "/team",
    RouteManagement: "/route-management-sv",
    RouteManagementEdit: "/route-management-sv/:routeId",
    RouteManagementMyRoute: "/route-management/my-route",
    RouteManagementAddMarket: "/route-management/add-market/:routeId",
    RouteManagementCreate: "/route-management-sv/new-route",
    RouteManagementCreateAddMarket:
        "/route-management-sv/new-route/add-market/",
    WorkPlanSV: "/work-plan-sv",

    // HR
    HRTeam: "/team-hr",
};
